var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-toolbar',{attrs:{"crumbs":_vm.crumbs}}),_c('topic-form',{attrs:{"value":_vm.topic,"mediaSelectorOptions":_vm.mediaSelectorOptions},on:{"cancel":_vm.onCancel,"save":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }